import React from "react";
import { debounce } from "@material-ui/core";

export default function useWindowSize(delay = 400): number[] {
  const [size, setSize] = React.useState([0, 0]);
  React.useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    const debouncedUpdate = debounce(updateSize, delay);
    window.addEventListener("resize", debouncedUpdate);
    debouncedUpdate();

    return () => window.removeEventListener("resize", debouncedUpdate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return size;
}
